import type {
  SupportedBridge,
  TokenDeployment,
} from "@src/components/DefuseSDK/types/base"

export function isCexIncompatible({ bridge }: { bridge: SupportedBridge }) {
  // These bridges may not be compatible with CEXs like Bybit, because
  // transfers are executed from a smart-contract account.
  const incompatibleBridges: SupportedBridge[] = [
    "direct",
    "hot_omni",
    "near_omni",
  ]

  return incompatibleBridges.includes(bridge)
}

// Aleo transfers arrive as private records that some exchanges can't credit —
// same loss risk as a CEX-incompatible bridge, so it gets the same gate.
export function requiresExchangeFundsAck(deployment: TokenDeployment): boolean {
  return isCexIncompatible(deployment) || deployment.chainName === "aleo"
}
